import Vue from 'vue';
import Vuetify from 'vuetify';
import DatetimePicker from 'vuetify-datetime-picker'
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.css';


Vue.use(Vuetify);
Vue.use(DatetimePicker);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            dark: {
                primary: '#009688',
                secondary: '#009688',
            },
            light: {
                primary: '#009688',
                secondary: '#009688',
            }
        }
    }
})